import StorageHelper from 'Src/helpers/storage/storage';
import { LoginSession, RoleSession } from '../../models/sessions';

export interface LoginSessionPersistenceOptions {
  remember?: boolean;
}

export function getSessions(): { loginSession: LoginSession; roleSession: RoleSession } {
  return {
    loginSession: StorageHelper.Cookie.get('loginSession'),
    roleSession: StorageHelper.SessionStorage.get('roleSession')
  };
}

export function getUserIdFromSession(loginSession: LoginSession, roleSession: RoleSession) {
  switch (true) {
    case typeof roleSession !== 'undefined':
      return roleSession.userId;
    case typeof loginSession !== 'undefined':
      return loginSession.userId;
    default:
      return undefined;
  }
}

export function getUserRoleFromSession(roleSession: RoleSession) {
  return typeof roleSession !== 'undefined' ? roleSession.role : undefined;
}

export function getActiveSchoolId() {
  return StorageHelper.SessionStorage.get('activeSchoolId');
}

export function getActiveSchoolName() {
  return StorageHelper.SessionStorage.get('activeSchoolName');
}

export function getActivePermission() {
  return StorageHelper.SessionStorage.get('activePermission');
}

export function clearSessions(): void {
  StorageHelper.SessionStorage.remove('activeSchoolId');
  StorageHelper.SessionStorage.remove('activeSchoolName');
  StorageHelper.Cookie.remove('loginSession');
  StorageHelper.Cookie.remove('loginSession', { domain: '.squadintouch.com' });
  StorageHelper.SessionStorage.remove('roleSession');
  StorageHelper.SessionStorage.remove('activePermission');
}

/**
 * Activates a login session without carrying an old role/school context into
 * the new identity. LocalStorage is deliberately left untouched because it
 * contains user-scoped UI preferences such as column visibility.
 */
export function replaceLoginSession(
  loginSession: LoginSession,
  options: LoginSessionPersistenceOptions = {}
): void {
  if (!loginSession || !loginSession.userId || !loginSession.key) {
    throw new Error('Cannot activate an invalid login session');
  }

  clearRole();
  StorageHelper.Cookie.remove('loginSession');
  StorageHelper.Cookie.remove('loginSession', { domain: '.squadintouch.com' });

  if (options.remember) {
    StorageHelper.Cookie.set('loginSession', loginSession, { expires: 365 });
  } else {
    StorageHelper.Cookie.set('loginSession', loginSession);
  }
}

export function clearRole(): void {
  StorageHelper.SessionStorage.remove('activeSchoolId');
  StorageHelper.SessionStorage.remove('activeSchoolName');
  StorageHelper.SessionStorage.remove('roleSession');
  StorageHelper.SessionStorage.remove('activePermission');
}
